/* nanoblock redesign v20 — small behaviours: rails, "+ more" rows, quick add, film lightbox, product gallery, sticky buy bar */
(function(){
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}

  /* product rails: arrow buttons */
  qsa('.nb-rbtn').forEach(function(b){
    b.addEventListener('click',function(){
      var r=document.getElementById(b.getAttribute('data-rail')); if(!r) return;
      var dir=b.classList.contains('nb-prev')?-1:1;
      r.scrollBy({left:dir*r.clientWidth*0.8,behavior:'smooth'});
    });
  });
  /* grey out an arrow when the rail can't scroll further that way */
  qsa('.nb-rail').forEach(function(r){
    var btns=qsa('.nb-rbtn[data-rail="'+r.id+'"]'); if(!btns.length) return;
    function upd(){ var max=r.scrollWidth-r.clientWidth-2; btns.forEach(function(b){ var prev=b.classList.contains('nb-prev'); b.classList.toggle('nb-dis', prev ? r.scrollLeft<=2 : r.scrollLeft>=max); }); }
    r.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd(); setTimeout(upd,800);
  });

  /* shop your way: "+ N more" expands the row in place */
  qsa('.nb-lic-t.nb-more').forEach(function(b){
    var label=b.querySelector('b'), plus=b.querySelector('.nb-plus'), orig=label?label.textContent:'';
    b.addEventListener('click',function(){
      var g=b.closest('.nb-lic'); var open=g.classList.toggle('nb-open');
      b.setAttribute('aria-expanded',open?'true':'false');
      if(plus) plus.textContent=open?'–':'+';
      if(label) label.textContent=open?'Show less':orig;
      if(open && window.jQuery && window.jQuery.fn && typeof window.jQuery(window).trigger==='function'){ window.jQuery(window).trigger('scroll'); }
    });
  });

  /* quick add on product cards (delegated, so cards rendered later by filters work too) */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-nb-add]'); if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    if(btn.classList.contains('nb-busy')) return;
    var id=btn.getAttribute('data-nb-add'); var txt=btn.querySelector('i');
    btn.classList.add('nb-busy');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        if(txt) txt.textContent='Added ✓'; btn.classList.remove('nb-busy'); btn.classList.add('nb-added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var done=Promise.resolve();
        try{ if(typeof window.monster_refresh==='function'){ done=Promise.resolve(window.monster_refresh()); } }catch(err){}
        done.then(function(){
          try{ if(typeof window.openCart==='function'){ window.openCart(); return; } }catch(err){}
          if(window.slidecarthq && typeof window.slidecarthq.open==='function'){ try{ window.slidecarthq.open(); }catch(err){} }
        });
        setTimeout(function(){ if(txt) txt.textContent='Add to cart'; btn.classList.remove('nb-added'); },2500);
      })
      .catch(function(){ btn.classList.remove('nb-busy'); window.location.href=btn.closest('a')?btn.closest('a').getAttribute('href'):'/cart'; });
  });

  /* film lightbox — one instance at a time; overlay wrapped in .nb-page so its styles apply */
  var nbLB=null;
  function nbCloseLB(){ if(!nbLB) return; var v=nbLB.querySelector('video'); if(v){ try{v.pause();}catch(e){} v.removeAttribute('src'); v.load(); } nbLB.remove(); nbLB=null; document.documentElement.style.overflow=''; document.body.style.overflow=''; }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') nbCloseLB(); });
  qsa('[data-nb-video]').forEach(function(el){
    el.addEventListener('click',function(e){
      e.preventDefault();
      var src=el.getAttribute('data-nb-video'); if(!src || nbLB) return;
      nbLB=document.createElement('div'); nbLB.className='nb-page nb-lbwrap';
      nbLB.innerHTML='<div class="nb-lightbox" role="dialog" aria-label="nanoblock film"><div class="nb-lightbox-inner"><button type="button" class="nb-lightbox-close" aria-label="Close">×</button><video controls playsinline preload="auto"></video></div></div>';
      document.body.appendChild(nbLB); document.documentElement.style.overflow='hidden'; document.body.style.overflow='hidden';
      var v=nbLB.querySelector('video'); v.src=src; var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
      nbLB.addEventListener('click',function(ev){ if(ev.target.classList.contains('nb-lightbox')||ev.target.closest('.nb-lightbox-close')) nbCloseLB(); });
    });
  });

  /* product page: thumbnails swap main image */
  var main=qs('.nb-gallery .nb-main img');
  if(main){
    qsa('.nb-gallery .nb-thumbs div').forEach(function(t){
      t.addEventListener('click',function(){
        var img=t.querySelector('img'); if(!img) return;
        main.src=img.getAttribute('data-large')||img.src;
        qsa('.nb-gallery .nb-thumbs div').forEach(function(x){x.classList.remove('nb-on')}); t.classList.add('nb-on');
      });
    });
  }

  /* product page: sticky buy bar mirrors the real add-to-cart button, and hides while that button is on screen */
  var bar=qs('.nb-stickybar'), realBtn=qs('#add') || qs('.nb-buy form [type="submit"], .nb-buy .nb-btn-primary');
  if(bar && realBtn){
    var barBtn=qs('.nb-btn',bar);
    if(barBtn) barBtn.addEventListener('click',function(e){ e.preventDefault(); realBtn.click(); });
    if('IntersectionObserver' in window){
      bar.classList.add('nb-hidden');
      new IntersectionObserver(function(en){ var onScreen=en[0].isIntersecting || en[0].boundingClientRect.top>window.innerHeight; bar.classList.toggle('nb-hidden',onScreen); },{threshold:0}).observe(realBtn);
    }
  }
})();
